import { useTheme } from '@/presentation/contexts/ThemeContext';
import { useResponsiveDesign } from '@/presentation/responsiveDesign/responsiveDesign';
import { AssetIcon } from '@/presentation/components/common/icon/AssetIcon';

export const ForwardChevronIcon = () => {
  const { theme } = useTheme();
  const responsive = useResponsiveDesign();

  return (
    <div style={{ marginLeft: responsive.spacing.sm, flexShrink: 0 }}>
      <AssetIcon
        path="/assets/vectors/chevron_right.svg"
        width={responsive.icon.small}
        height={responsive.icon.small}
        color={theme.icon.secondary}
      />
    </div>
  );
};
